'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ResponsiveImage = require('./ResponsiveImage');

Object.defineProperty(exports, 'ResponsiveImage', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ResponsiveImage).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/responsiveImage/index.js
// module id = 597
// module chunks = 0